'use strict';

import {TrackingFeature, TrackingFeatureLabels} from "../types";

export default class Slide {

    private readonly slideDom : Element;
    private urlPath: string;
    readonly hasLever: boolean;
    readonly featureLabels: TrackingFeatureLabels;
    readonly leverTrackingPayload?: TrackingFeature;
    readonly position: number;


    constructor(slideDom: Element, index: number) {
        this.slideDom = slideDom;
        this.position = index + 1;
        this.urlPath = slideDom.querySelector("a")!.getAttribute("href")!;
        this.featureLabels = JSON.parse(slideDom.getAttribute('data-feature-labels')!);
        this.hasLever = slideDom.querySelectorAll(".promo_shoppromo-large--lever-tag").length > 0;
        if (this.hasLever) {
            this.leverTrackingPayload = JSON.parse(slideDom.querySelector(".promo_shoppromo-large--lever-tag")!.getAttribute("data-tracking-payload")!);
        }
    }

    setIsTracked() {
        this.slideDom.setAttribute("data-slidetracked", 'true');
    }

    isTracked() : boolean {
        return Boolean(this.slideDom.getAttribute("data-slidetracked"));
    }

    registerClickEventHandler(eventHandler: (e: Event) => void) {
        this.slideDom.addEventListener("click", eventHandler);
    }

    registerLeverClickEventListener(eventHandler: (e: Event) => void) {
        const leverElement = this.slideDom.querySelector(".promo_shoppromo-large--lever-tag")!;
        leverElement.addEventListener("click", eventHandler);
    }


    /*🤫*/
    click() {
        (this.slideDom as HTMLElement).click();
    }
}